"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEGMENT_RESTORATION = exports.LIST_SEGMENTS = void 0;
const react_1 = __importStar(require("react"));
const schema_1 = __importDefault(require("./schema"));
const dataTransferSchema_1 = __importDefault(require("./dataTransferSchema"));
const models_hook_1 = require("app/models.hook");
const route_1 = require("../route");
const auth_1 = require("common/auth");
const schemaComponents_1 = require("@/schemaComponents");
const copilotApi_1 = require("@/schemaComponents/modules/copilotApi");
const list_1 = __importDefault(require("./restoration/list"));
const index_1 = require("../../../../index");
exports.LIST_SEGMENTS = route_1.SEGMENTS.sub("/list", Segments);
exports.SEGMENT_RESTORATION = route_1.SEGMENTS.sub("/restore", list_1.default);
function Segments({ projectId }) {
    (0, auth_1.useProjectPageAuthorization)(projectId);
    const { conditionSelector, filterComponent, condition } = (0, schemaComponents_1.useConditionSelector)({
        schema: (0, dataTransferSchema_1.default)({ projectId }),
        hideTimeCondition: true,
    });
    // condition に aiSearch が入っている場合、まず Segment ID のリストを取得する
    const aiSearchParam = (() => {
        var _a, _b;
        const aiSearchParam = (_b = (_a = condition === null || condition === void 0 ? void 0 : condition.aiSearch) === null || _a === void 0 ? void 0 : _a.$matchIntl) !== null && _b !== void 0 ? _b : null;
        if (!aiSearchParam || typeof aiSearchParam !== "string")
            return null;
        return aiSearchParam;
    })();
    const [aiSearchSegments, setAiSearchSegments] = (0, react_1.useState)([]);
    const [aiSearchLoading, setAiSearchLoading] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (!aiSearchParam) {
            setAiSearchSegments([]);
            return;
        }
        let stale = false;
        (() => __awaiter(this, void 0, void 0, function* () {
            try {
                let hitSegmentId = [];
                setAiSearchLoading(true);
                const newSegments = yield (0, copilotApi_1.searchSegment)({
                    text: aiSearchParam.toLowerCase(),
                    projectId,
                    exceptSegmentId: hitSegmentId,
                });
                if (stale)
                    return;
                hitSegmentId = newSegments;
                setAiSearchSegments(hitSegmentId);
            }
            catch (e) {
                if (stale)
                    return;
                setAiSearchSegments([]);
            }
            finally {
                setAiSearchLoading(false);
            }
        }))();
        return () => {
            stale = true;
        };
    }, [aiSearchParam]);
    const mergedCondition = (0, react_1.useMemo)(() => {
        if (!aiSearchParam)
            return condition;
        return {
            segmentId: {
                $in: aiSearchSegments,
            },
        };
    }, [aiSearchParam, condition, aiSearchSegments]);
    // 次に、 Segment ID のリストを元に filter する
    const { list, loading, upsert, hasMore, refresher, fetching, reload } = (0, models_hook_1.useSegmentList)({
        projectId,
        condition: mergedCondition,
    });
    const parameter = (0, react_1.useMemo)(() => ({
        title: "翻訳ファイル一覧",
        breadcrumbConfigs: [
            {
                name: "プロジェクト一覧",
                path: (0, index_1.resolveRoute)("LIST_PROJECTS"),
            },
            {
                name: "翻訳ファイル一覧",
                path: (0, index_1.resolveRoute)("LIST_SEGMENTS", { projectId }),
            },
        ],
        edit: {
            path: ({ segmentId }) => (0, index_1.resolveRoute)("LIST_SEGMENT_SCRIPTS", { segmentId, projectId }),
        },
        create: {
            path: () => (0, index_1.resolveRoute)("ADD_NEW_SEGMENT", { projectId }, {
                searchParams: { edit: "1" },
            }),
        },
        schema: (0, schema_1.default)({ projectId }),
        download: {
            schema: (0, dataTransferSchema_1.default)({ projectId }),
            filename: `segments-${projectId}`,
            isDisabled: true,
        },
    }), [projectId]);
    const { list: comments } = (0, models_hook_1.useCommentList)({
        projectId,
    });
    const commentsMap = (0, react_1.useMemo)(() => {
        var _a;
        return (_a = (comments !== null && comments !== void 0 ? comments : [])) === null || _a === void 0 ? void 0 : _a.reduce((acc, comment) => {
            if (!comment.resolved) {
                if (!acc[comment.segmentId]) {
                    acc[comment.segmentId] = [];
                }
                acc[comment.segmentId].push(comment);
            }
            return acc;
        }, {});
    }, [comments]);
    const segmentListWithComments = (0, react_1.useMemo)(() => {
        return list.map((segment) => {
            var _a;
            const comments = (_a = commentsMap[segment.segmentId]) !== null && _a !== void 0 ? _a : [];
            return Object.assign(Object.assign({}, segment), { unresolvedComments: comments.length });
        });
    }, [commentsMap, list]);
    return (react_1.default.createElement(schemaComponents_1.SchemaListPage, { parameter: parameter, list: segmentListWithComments, loading: loading, hasMore: hasMore, fetching: fetching || aiSearchLoading, refresher: refresher, reload: reload, filterComponent: filterComponent }));
}
exports.default = Segments;
